'use strict';

/**
 * View for recursive rendering of the nested storages
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');

var template = require('../../templates/partials/manage-storage-list-item.hbs');

var ManageStorageListItem = ColidoCompositeView.extend({
    template: template,

    tagName: 'li',

    className: 'dd-item',

    childViewContainer: 'ol',

    sortDefault: 'sortOrder.asc-name.asc',

    attributes: function() {
        return {
            'data-id': this.model.id,
            'data-dirty': 0,
        };
    },

    initialize: function(options) {
        ColidoCompositeView.prototype.initialize.apply(this, arguments);

        var catalog = this.model.collection.catalog;

        this.collection =  catalog.storages.getFilteredCollection(function(collectionModel) {
            return this.model.get('id') === collectionModel.get('parent');
        }.bind(this));
    },
});

module.exports = ManageStorageListItem;